import React from 'react';
import LoginForm from './LoginForm';
import OtpForm from './OtpForm';

import { useAuth } from 'hooks/useAuth';
import useTitle from 'hooks/useTitle';
import './index.scss';

import cayeshLogo from 'assets/images/logo.png';
import loginBg from 'assets/images/login-bg.png';
import { useTranslation } from 'react-i18next';

const Login = () => {
	const { isAuthenticated } = useAuth();
	const { t } = useTranslation();
	useTitle('Login');

	// const [otp, setOtpStep] = useState(false);

	const otpStepSubmit = () => {
		// setOtpStep(true);
	};

	return (
		<div className='d-flex flex-row' style={{ height: '100vh' }}>
			<div className='form-login-wrapper align-items-center justify-content-center px-5 m-auto'>
				<img src={cayeshLogo} alt='' className='img-fluid logo'/>
				<div className='w-100 '>
					<h3 className='text-start mb-3'>{t("Log in")}</h3>
					{!isAuthenticated ? <LoginForm otpStepSubmit={otpStepSubmit} /> : <OtpForm />}
				</div>
			</div>
		</div>
	);
};
export default Login;
